module.exports = __webpack_public_path__ + "static/media/profileImage.54ee23fc.jpg";